var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_695_10872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.27539 1.99121L25.1687 23.1459",
    stroke: "#FE4B4E",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1687 1.99121L2.27539 23.1459",
    stroke: "#FE4B4E",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_10872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1638,
    height: 24.1768,
    fill: "white",
    transform: "translate(0.640625 0.480469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.19b0ed45480e5c83572948bd09ab514d.svg";
export { ForwardRef as ReactComponent };